import Man from "././../Assets/Icons/Man.png";
import londonbackground from "././../Assets/Icons/groupJobs.svg";
import Multiselect from "multiselect-react-dropdown";
import { Button as AntdButton, Button, Tooltip } from "antd";
import JobService from "../Service.js/jobService";
import { useEffect, useRef } from "react";
import { useState } from "react";
import { TbCurrencyRupee } from "react-icons/tb";
import { TiLocationArrowOutline } from "react-icons/ti";
import { MdOutlineWorkOutline } from "react-icons/md";
import { Link, useNavigate, useParams } from "react-router-dom";
import Header from "./Header";
import FooterLayout from "../Components/FooterLayout";
import tickIcon from "../Assets/Icons/tick.svg";
import CandidateLogin from "./CandidateLogin";
import cartIcon from "../Assets/Icons/cart.svg";
import toast from "react-hot-toast";
import Pagination from "../Components/CommonCommponents/Pagination";
import cartIcon2 from "../Assets/Icons/cart2.svg";
import EmployeeRefer from "./EmployeeRefer";
import { Progress, Modal } from "antd";
import { useFetchAllListedJobs } from "../ServiceHooks/jobHooks";
import { Helmet } from "react-helmet-async";
import { helmetJsonLdProp } from "react-schemaorg";
import HireHubHeader from "./HireHubHeader";
import { IoArrowBackSharp } from "react-icons/io5";

const jobListingStructuredData = [
  {
    "@context": "https://schema.org",
    "@type": "JobPosting",
    title: "Software Engineer",
    description:
      "We are looking for a skilled software engineer to join our team...",
    datePosted: "2024-07-17",
    validThrough: "2024-08-17",
    employmentType: "FULL_TIME",
    hiringOrganization: {
      "@type": "Organization",
      name: "Example Company",
      sameAs: "https://example.com",
    },
    jobLocation: {
      "@type": "Place",
      address: {
        "@type": "PostalAddress",
        streetAddress: "123 Main St",
        addressLocality: "City",
        addressRegion: "State",
        postalCode: "12345",
        addressCountry: "US",
      },
    },
    baseSalary: {
      "@type": "MonetaryAmount",
      currency: "USD",
      value: {
        "@type": "QuantitativeValue",
        value: 60000,
        unitText: "YEAR",
      },
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "JobPosting",
    title: "Product Manager",
    description:
      "We are seeking an experienced product manager to oversee our new products...",
    datePosted: "2024-07-10",
    validThrough: "2024-08-10",
    employmentType: "FULL_TIME",
    hiringOrganization: {
      "@type": "Organization",
      name: "Example Company",
      sameAs: "https://example.com",
    },
    jobLocation: {
      "@type": "Place",
      address: {
        "@type": "PostalAddress",
        streetAddress: "123 Main St",
        addressLocality: "City",
        addressRegion: "State",
        postalCode: "12345",
        addressCountry: "US",
      },
    },
    baseSalary: {
      "@type": "MonetaryAmount",
      currency: "USD",
      value: {
        "@type": "QuantitativeValue",
        value: 80000,
        unitText: "YEAR",
      },
    },
  },
];

const Jobs = () => {
  const navigate = useNavigate();
  const [jobDetails, setJobDetails] = useState();
  const [showAll, setShowAll] = useState(false);
  const [open, setOpen] = useState(false);
  const [autofills, setAutoFills] = useState("");
  const [searchString, setSearchString] = useState("");
  const [selectedValue, setSelectedValue] = useState({
    skills: "",
    title: "",
    location: "",
  });
  const [isModalOpen, setModalOpen] = useState(false);
  const [jobId, setJobId] = useState();
  const currentUser = localStorage.getItem("candidate");
  const user = JSON.parse(currentUser)?.is_recruiter_staff;
  const multiselectRef = useRef(null);

  useEffect(() => {
    const input = multiselectRef.current?.querySelector("input");
    if (input) {
      input.focus();
    }
  }, []);

  console.log("currentIser", user);
  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };
  const calculatePaginationData = (page, totalItems, pageSize) => {
    //console.log("testings",{page, totalItems, pageSize});
    const start = page * pageSize + 1;
    const end =
      (page + 1) * pageSize < totalItems ? (page + 1) * pageSize : totalItems;
    // offset is 0 for first element
    const offset = page * pageSize;
    return {
      page,
      pageSize,
      offset,
      start,
      end,
    };
    // "page": 0,
    // "pageSize": 5,
    // "offset": 0
  };
  const dropDownOPtions = (data) => {
    var options = [];
    for (var i = 0; i < data.length; i++) {
      options.push({
        id_alias: data[i].id_alias,
        name: data[i].name,
        type: data[i].type,
      });
    }
    return options;
  };
  const handleReferCandidates = (job_id) => {
    setModalOpen(true);
    setJobId(job_id);
  };
  const handleChange = async () => {
    console.log(selectedValue, "searchsearch");
    const skills = selectedValue.skills
      ? selectedValue.skills.map((i) => i.name).toString()
      : "";
    const title = selectedValue.title
      ? selectedValue.title.map((i) => i.name).toString()
      : "";
    const location = selectedValue.location
      ? selectedValue.location.map((i) => i.name).toString()
      : "";
    console.log(skills, "searchsearch");
    console.log(title, "searchsearch");
    console.log(location, "searchsearch");
    await JobService.searchJob(skills, title, location)
      .then((response) => {
        setJobDetails(response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const handleSerachSelect = (data) => {
    console.log("fsqy", data);
    const skills = [];
    const titles = [];
    const locations = [];
    for (var i = 0; i < data.length; i++) {
      if (data[i].type == "skill") {
        skills.push({
          id_alias: data[i].id_alias,
          name: data[i].name,
          type: data[i].type,
        });
      }
      if (data[i].type == "title") {
        titles.push({
          id_alias: data[i].id_alias,
          name: data[i].name,
          type: data[i].type,
        });
      }
      if (data[i].type == "location") {
        locations.push({
          id_alias: data[i].id_alias,
          name: data[i].name,
          type: data[i].type,
        });
      }
      setSelectedValue({ skills: skills, title: titles, location: locations });
    }
  };
  const handelPaginationModel = (paginationModel) => {
    jobList(paginationModel?.pageSize, paginationModel?.offset, selectedValue);
  };
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
    offset: 0,
    start: 0,
    end: 0,
  });
  // const { data } = useFetchAllListedJobs({
  //   params: {
  //     offset: paginationModel.offset,
  //     limit: paginationModel.pageSize,
  //   },
  // });
  const jobList = async (pageSize, offset, searchValue) => {
    console.log("selectedValue", selectedValue);
    const skills = searchValue?.skills
      ? searchValue?.skills.map((i) => i.name).toString()
      : "";
    const title = searchValue?.title
      ? searchValue?.title.map((i) => i.name).toString()
      : "";
    const location = searchValue?.location
      ? searchValue?.location.map((i) => i.name).toString()
      : "";

    await JobService.jobList(pageSize, offset, skills, title, location)
      .then((response) => {
        setJobDetails(response?.data?.data);
      })
      .catch((err) => {});
  };
  const removeTags = (input) => {
    //return input.replace(/<[^>]*>/g, '');
    return input.replace(/<[^>]*>|&nbsp;/g, "");
  };
  const truncateStrHandler = (str) => {
    const stringWithoutTags = removeTags(str);
    return stringWithoutTags.length > 65
      ? stringWithoutTags.substring(0, 65) + "  ....."
      : str;
  };
  const skillStrHandler = (str) => {
    return str.length > 10 ? str.substring(0, 8) + "...." : str;
  };
  const handlesearch = async (serachValue) => {
    setSearchString(serachValue);
    await JobService.autofill(serachValue)
      .then((response) => {
        setAutoFills(response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const handelRemove = (data) => {
    console.log("fsqy", data);
    if (data.length === 0) {
      jobList();
    }
  };
  console.log("jobDetails", jobDetails);
  useEffect(() => {
    // handelPaginationModel(paginationModel.pageSize, paginationModel.offset);
    jobList(paginationModel.pageSize, paginationModel.offset, selectedValue);
  }, [isModalOpen]);

  const handleCart = async (jobId) => {
    await JobService.addToCart(jobId)
      .then((response) => {
        toast.success("Added To BookMark");
        jobList();
      })
      .catch((error) => {
        toast.error("Failed To Add");
      });
  };
  const deleteCart = async (jobId) => {
    await JobService.deleteCart(jobId)
      .then((response) => {
        toast.success("Removed from BookMark");
        jobList();
      })
      .catch((error) => {
        toast.error("Failed To Add");
      });
  };
  return (
    <>
      <Helmet
        prioritizeSeoTags
        script={[helmetJsonLdProp(jobListingStructuredData)]}
      >
        <title>Job Listings</title>
        <meta name="description" content="Latest job listings" />
      </Helmet>

      <div className="w-full pageContent scrollbar-hide ">
        <div className="flex items-center justify-end w-full lg:w-[82%]">
          <HireHubHeader />
        </div>
        <div className="">
          <div className="mt-2 chart_div">
            <div
              className="flex flex-row flex-wrap sm:items-end items-center justify-center sm:w-4/6 w-[85%]"
              style={{
                backgroundImage: `url(${londonbackground})`,
                backgroundSize: "cover",
              }}
            >
              <div className="">
                <img src={Man} alt="man" />
              </div>
              <div className="md:w-3/4 sm:w-full xs:w-full">
                <div className="text-center mb-5">
                  <p className="font-bold md:text-5xl sm:text-xl item-center ">
                    Find your job now !
                  </p>
                </div>
                <div className="relative" ref={multiselectRef}>
                  <Multiselect
                    className="md:pl-20 sm:pr-2 ml-0"
                    options={dropDownOPtions(autofills)} // Options to display in the dropdown
                    onSelect={handleSerachSelect} // Function will trigger on select event
                    onRemove={handelRemove} // Function will trigger on remove event
                    displayValue="name" // Property name to display in the dropdown options
                    onSearch={handlesearch}
                    placeholder="Enter skills / designations"
                  />
                  <Button
                    className="absolute px-10 right-3 top-3 custom-button "
                    onClick={(e) => {
                      handleChange();
                    }}
                  >
                    Search
                  </Button>
                </div>
              </div>
            </div>
            <div className="mt-20 1xl:w-5/6 xs-xl:w-5/6 lg:w-5/6 2xl:w-4/6 sm:w-full xs:w-full sm:px-4 xs:px-6">
              <div className="flex items-center">
                <p
                  className="flex items-center gap-2 cursor-pointer text-2xl font-semibold mr-2"
                  onClick={() => navigate("/")}
                >
                  <IoArrowBackSharp />
                  {/* Back */}
                </p>
                {/* <p className="text-2xl font-semibold">Jobs</p> */}
                <div className="p-1 mx-4 border border-gray-400 rounded-full">
                  <p className="px-4 pt-1 text-sm font-semibold">
                    {jobDetails?.count} new jobs
                  </p>
                </div>
              </div>
              <div className="flex flex-row flex-wrap ">
                {jobDetails?.results?.map((item, index) => {
                  const colors = ["#ffffff"];
                  const noDataMessage = "Not Assigned";
                  const locations = item.locations?.map((obj) => obj);
                  return (
                    <div className="px-2 mt-6 lg:w-1/2 md:w-full xl:w-1/2 sm:w-full xs:w-full sm:flex-col md:flex-row">
                      <div
                        className="p-3 border border-gray-300 cursor-pointer rounded-xl"
                        onClick={() => navigate(`/jobDetails/${item?.id}`)}
                        style={{
                          backgroundColor: colors[index % colors.length],
                        }}
                      >
                        <div className="px-4 ">
                          <div className="flex items-center justify-between">
                            <Link to={`/jobDetails/${item.id}`}>
                              <p className="mt-2 text-base font-semibold text-left">
                                {item?.title}
                              </p>
                            </Link>
                            <div className="flex flex-row justify-between">
                              {currentUser ? (
                                item.is_saved === false ? (
                                  <div className="pt-2">
                                    <Tooltip
                                      placement="bottom"
                                      title="save job"
                                    >
                                      <button
                                        type="button"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleCart(item.id);
                                        }}
                                      >
                                        <img
                                          alt="cart"
                                          src={cartIcon}
                                        />
                                      </button>
                                    </Tooltip>
                                  </div>
                                ) : (
                                  <div className="pt-2">
                                    <Tooltip
                                      placement="bottom"
                                      title="saved job"
                                    >
                                      <button
                                        type="button"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          deleteCart(item.id);
                                        }}
                                      >
                                        <img
                                          alt="cart"
                                          className=""
                                          src={cartIcon2}
                                        />
                                      </button>
                                    </Tooltip>
                                  </div>
                                )
                              ) : (
                                ""
                              )}
                            </div>
                          </div>

                          <p className="font-sans text-sm font-semibold">
                            {item?.client_name}
                          </p>

                          <div className="w-full mt-4">
                            <ul className="md:flex md:flex-wrap sm:flex-col md:flex-row">
                              <li className="w-full mb-4">
                                <div className="md:flex md:flex-wrap sm:flex-col md:flex-row">
                                  {item.experience != false && (
                                    <span className="flex items-center mr-4">
                                      <MdOutlineWorkOutline className="mr-2" />
                                      {item.experience}
                                    </span>
                                  )}
                                  {item.experience != false &&
                                    (item.salary_details != false ||
                                      item.salary_confidential != false) && (
                                      <span className="mx-4 divider xs:hidden sm:hidden md:inline-block">
                                        |
                                      </span>
                                    )}
                                  {item.salary_confidential === true ? (
                                    <span className="flex items-center">
                                      <TbCurrencyRupee className="mr-2 contentIcon" />
                                      <p>As per the industrial standard</p>
                                    </span>
                                  ) : (
                                    item.salary_details != false && (
                                      <span className="flex items-center">
                                        <TbCurrencyRupee className="mr-2 contentIcon" />
                                        {item.salary_details}
                                      </span>
                                    )
                                  )}
                                  {(item.salary_details != false ||
                                    item.salary_confidential != false) &&
                                    item.job_type && (
                                      <span className="mx-4 divider xs:hidden sm:hidden md:inline-block">
                                        |
                                      </span>
                                    )}
                                  {item.experience != false &&
                                    item.job_type &&
                                    item.salary_details == false &&
                                    item.salary_confidential == false && (
                                      <span className="hidden mx-4 divider sm:inline-block">
                                        |
                                      </span>
                                    )}
                                  {item.job_type && (
                                    <span className="flex items-center mr-4">
                                      <TiLocationArrowOutline className="mr-2 contentIcon" />
                                      {item.job_type}
                                    </span>
                                  )}
                                </div>
                              </li>
                            </ul>
                          </div>
                          <div className="flex flex-wrap mt-2">
                            <p className="text-xs font-normal text-gray-600 font-poppins line-clamp-1">
                              {removeTags(item.description, item.id)}
                            </p>
                            {/* {item?.description?.length > 65 ? (
                              <Link to={`/jobDetails/${item.id}`}>
                                <p className="flex text-xs font-normal text-gray-600 font-poppins flex-wap">
                                  more
                                </p>
                              </Link>
                            ) : (
                              ""
                            )} */}
                          </div>
                          <div className="flex flex-wrap w-3/4 pb-4 mt-4 ">
                            {showAll
                              ? item.required_skill?.map((skill, index) => (
                                  <div
                                    key={index}
                                    className="p-1 mt-2 border border-gray-400 rounded-3xl line-clamp-1"
                                  >
                                    <p
                                      className="px-2 pt-1 text-xs font-normal line-clamp-1"
                                      title={skill}
                                    >
                                      {skillStrHandler(skill)}
                                    </p>
                                  </div>
                                ))
                              : item.required_skill
                                  ?.slice(0, 3)
                                  .map((skill, index) => (
                                    <div
                                      key={index}
                                      className="p-1 mx-2 mt-2 border border-gray-400 rounded-3xl line-clamp-1"
                                    >
                                      <p
                                        className="px-2 pt-1 text-xs font-normal line-clamp-1"
                                        title={skill}
                                      >
                                        {skillStrHandler(skill)}
                                      </p>
                                    </div>
                                  ))}
                            {/* {item.required_skill?.length > 3 && (
                              <div
                                className="p-1 mt-2 cursor-pointer "
                                // onClick={() => setShowAll(true)}
                              >
                                <Link to={`/jobDetails/${item.id}`}>
                                  <p className="px-2 pt-1 text-xs font-normal text-gray-600">
                                    ...more
                                  </p>
                                </Link>
                              </div>
                            )} */}
                            {/* {item.required_skill?.length > 4 && !showAll && (
                            <div
                              className='p-1 mt-2 cursor-pointer '
                              onClick={() => setShowAll(true)}
                            >
                              <p className='px-2 pt-1 text-xs font-normal text-gray-600'>...more</p>
                            </div>
                          )} */}
                          </div>

                          <div className="mt-4">
                            <p>{locations.join("/")}</p>
                          </div>
                          <div className="pt-1 mt-2 bg-white rounded-xl">
                            <p>{item?.posted}</p>
                          </div>
                          <div className="flex flex-wrap mb-6 sm:justify-end xs:justify-start">
                            <div className="px-4">
                              {item.is_referred == true && (
                                <button
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    //setModalOpen(true);
                                  }}
                                  className=" text-[#0073E6] font-poppins text-base font-medium leading-normal underline mt-2"
                                >
                                  <Link to={`/employeeProfile/${item.id}`}>
                                    View References
                                  </Link>
                                </button>
                              )}
                            </div>
                            <div className="">
                              {user && (
                                <Button
                                  className="rounded-full text-[#3E94EB] text-base font-semibold font-poppins border border-[#3E94EB] cursor-pointer"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleReferCandidates(item.id);
                                  }}
                                  type="text"
                                >
                                  Refer now
                                </Button>
                              )}
                            </div>
                            {item?.current_status !== false && (
                              <div className="px-2">
                                <p className="px-2 pt-[6px] text-[#1C4980] text-base font-semibold">
                                  {item?.current_status}
                                </p>
                              </div>
                            )}
                            {currentUser === null ? (
                              <div>
                                {/* <Button
                                className="rounded-full text-[#3E94EB] text-base font-semibold font-poppins border border-[#3E94EB] "
                                onClick={showDrawer}
                              >
                                Login To Apply
                              </Button> */}
                              </div>
                            ) : item.applied === false ? (
                              <div className="flex flex-wrap">
                                {/* <div className="px-2">
                                  <Button className="rounded-full text-white bg-[#1C4980] text-base font-semibold">
                                    <Link to={`/jobDetails/${item.id}`}>
                                      Apply
                                    </Link>
                                  </Button>
                                </div> */}
                              </div>
                            ) : (
                              // <Button className="rounded-full text-white bg-[#1C4980] text-base font-semibold">
                              //   <Link to={`/jobDetails/${item.id}`}>
                              //     Apply
                              //   </Link>
                              // </Button>
                              <div className="flex flex-wrap px-2 py-1">
                                <div className="pt-1">
                                  <button className="flex flex-wrap ">
                                    <p className="px-2 stext-[#1C4980] text-base font-semibold">
                                      Applied
                                    </p>

                                    <img
                                      src={tickIcon}
                                      alt="work"
                                      className="w-4 h-auto mt-1 mr-3 contentIcon"
                                    />
                                  </button>
                                </div>
                              </div>
                            )}
                          </div>
                          <div className="flex justify-end items-center">
                            <p className="rounded-full text-[#3E94EB] text-base font-semibold font-poppins cursor-pointer">
                              Know More
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
              <div className="flex flex-wrap justify-end w-full mt-8 mb-4 ">
                <Pagination
                  className="AntPagination"
                  showSizeChanger={false}
                  defaultCurrent={0}
                  pageSize={paginationModel.pageSize}
                  current={paginationModel.page + 1}
                  total={jobDetails?.count}
                  onChange={(pageNumber) => {
                    const newPageNumber = pageNumber - 1;
                    const newPaginationData = calculatePaginationData(
                      newPageNumber,
                      jobDetails?.count,
                      paginationModel.pageSize,
                    );
                    console.log("newPaginationData", newPaginationData);
                    setPaginationModel(newPaginationData);
                    handelPaginationModel(newPaginationData);
                  }}
                />
                {/* <pre>{JSON.stringify(paginationModel, 2, null)}</pre> */}
              </div>
            </div>
            <div className="w-full mt-12">{/* <FooterLayout /> */}</div>
          </div>
        </div>
      </div>
      <Modal
        open={isModalOpen}
        title="Refer Your Friend"
        footer={null}
        width={700}
        onCancel={() => setModalOpen(false)}
        className=""
      >
        <div className="">
          <EmployeeRefer jobId={jobId} setModalOpen={setModalOpen} />
        </div>
      </Modal>
    </>
  );
  // return (
  //   <>
  //     <div className="w-full pageContent scrollbar-hide ">
  //       <div className=" lg:mx-10 xl:mx-20 2xl:40">
  //         <div>
  //           <div
  //             className="flex flex-row flex-wrap items-end md:px-40"
  //             style={{
  //               backgroundImage: `url(${londonbackground})`,
  //               backgroundSize: "cover",
  //             }}
  //           >
  //             <div className="">
  //               <img src={Man} alt="grouimah" />
  //             </div>
  //             <div className="md:w-3/4 sm:w-full">
  //               <div className="relative">
  //                 <Multiselect
  //                   className="pl-20"
  //                   options={dropDownOPtions(autofills)} // Options to display in the dropdown
  //                   onSelect={handleSerachSelect} // Function will trigger on select event
  //                   onRemove={handelRemove} // Function will trigger on remove event
  //                   displayValue="name" // Property name to display in the dropdown options
  //                   onSearch={handlesearch}
  //                   placeholder="Enter skills / designations / location"
  //                 />
  //                 <Button
  //                   className="absolute px-10 right-3 top-3 custom-button "
  //                   onClick={(e) => {
  //                     handleChange();
  //                   }}
  //                 >
  //                   Search
  //                 </Button>
  //               </div>
  //             </div>
  //           </div>
  //           <div className="mt-20">
  //             <div className="flex px-20">
  //               <p className="text-2xl font-semibold">Jobs</p>
  //               <div className="p-1 mx-4 border border-gray-400 rounded-full">
  //                 <p className="px-4 pt-1 text-sm font-semibold">
  //                   {jobDetails?.count} new jobs
  //                 </p>
  //               </div>
  //             </div>
  //           </div>
  //           <div className="flex flex-row flex-wrap px-10 md:px-20">
  //             {jobDetails?.results?.map((item, index) => {
  //               const colors = ["#F2F8F8"];
  //               const noDataMessage = "Not Assigned";
  //               const locations = item.locations?.map((obj) => obj);

  //               return (
  //                 <div className="w-full px-2 mt-6 lg:w-1/2 md:w-full xl:w-1/2 ">
  //                   <div className="p-3 border border-gray-300 rounded-md">
  //                     <div
  //                       onClick={() => navigate(`/jobDetails/${item.id}`)}
  //                       className="rounded-lg cursor-pointer"
  //                       style={{
  //                         backgroundColor: colors[index % colors.length],
  //                       }}
  //                     >
  //                       <div className="px-4 ">
  //                         <div className="flex flex-row justify-between ">
  //                           <div className="px-2 pt-1 mt-2 bg-white rounded-xl">
  //                             <p>{item?.posted}</p>
  //                           </div>
  //                           {currentUser ? (
  //                             item.is_saved === false ? (
  //                               <div className="pt-2">
  //                                 <button>
  //                                   <img
  //                                     alt="cart"
  //                                     src={cartIcon}
  //                                     onClick={() => handleCart(item.id)}
  //                                   />
  //                                 </button>
  //                               </div>
  //                             ) : (
  //                               <div className="pt-2">
  //                                 <button>
  //                                   <img
  //                                     alt="cart"
  //                                     className=""
  //                                     src={cartIcon2}
  //                                     onClick={() => deleteCart(item.id)}
  //                                   />
  //                                 </button>
  //                               </div>
  //                             )
  //                           ) : (
  //                             ""
  //                           )}
  //                         </div>
  //                         <Link to={`/jobDetails/${item.id}`}>
  //                           <p className="mt-2 text-base font-semibold">
  //                             {item?.title}
  //                           </p>
  //                         </Link>
  //                       </div>
  //                       <div className="w-full mx-4 mt-4">
  //                         <ul className="flex flex-wrap ">
  //                           <li className="w-full mb-4">
  //                             <div className="flex flex-wrap ">
  //                               {item.experience != false && (
  //                                 <span className="flex items-center mr-4">
  //                                   <MdOutlineWorkOutline className="mr-2" />
  //                                   {item.experience}
  //                                 </span>
  //                               )}
  //                               {item.experience != false &&
  //                                 item.salary_details && (
  //                                   <span className="mx-4 divider">|</span>
  //                                 )}
  //                               {item.salary_confidential === true ? (
  //                                 <span className="flex items-center">
  //                                   <TbCurrencyRupee className="mr-2 contentIcon" />
  //                                   <p>As per the industrial standard</p>
  //                                 </span>
  //                               ) : (
  //                                 item.salary_details != false && (
  //                                   <span className="flex items-center">
  //                                     <TbCurrencyRupee className="mr-2 contentIcon" />
  //                                     {item.salary_details}
  //                                   </span>
  //                                 )
  //                               )}
  //                               {(item.salary_details != false ||
  //                                 item.salary_confidential != false) &&
  //                                 item.job_type && (
  //                                   <span className="mx-4 divider">|</span>
  //                                 )}
  //                               {item.experience != false &&
  //                                 item.job_type &&
  //                                 item.salary_details == false && (
  //                                   <span className="hidden mx-4 divider sm:inline-block">
  //                                     |
  //                                   </span>
  //                                 )}
  //                               {item.job_type && (
  //                                 <span className="flex items-center mr-4">
  //                                   <TiLocationArrowOutline className="mr-2 contentIcon" />
  //                                   {item.job_type}
  //                                 </span>
  //                               )}
  //                             </div>
  //                           </li>
  //                         </ul>
  //                       </div>
  //                       <div className="flex flex-wrap mt-2">
  //                         <p className="pl-4 text-xs font-normal text-gray-600 font-poppins">
  //                           {removeTags(
  //                             truncateStrHandler(item.description, item.id)
  //                           )}
  //                         </p>
  //                         {item?.description?.length > 65 ? (
  //                           <Link to={`/jobDetails/${item.id}`}>
  //                             <p className="flex text-xs font-normal text-gray-600 font-poppins flex-wap">
  //                               more
  //                             </p>
  //                           </Link>
  //                         ) : (
  //                           ""
  //                         )}
  //                       </div>
  //                       <div className="flex flex-wrap w-3/4 pb-4 mt-4 ">
  //                         {showAll
  //                           ? item.required_skill?.map((skill, index) => (
  //                               <div
  //                                 key={index}
  //                                 className="p-1 mt-2 border border-gray-400 rounded-3xl"
  //                               >
  //                                 <p
  //                                   className="px-2 pt-1 text-xs font-normal"
  //                                   title={skill}
  //                                 >
  //                                   {skillStrHandler(skill)}
  //                                 </p>
  //                               </div>
  //                             ))
  //                           : item.required_skill
  //                               ?.slice(0, 3)
  //                               .map((skill, index) => (
  //                                 <div
  //                                   key={index}
  //                                   className="p-1 mx-2 mt-2 border border-gray-400 rounded-3xl"
  //                                 >
  //                                   <p
  //                                     className="px-2 pt-1 text-xs font-normal"
  //                                     title={skill}
  //                                   >
  //                                     {skillStrHandler(skill)}
  //                                   </p>
  //                                 </div>
  //                               ))}
  //                         {item.required_skill?.length > 3 && (
  //                           <div
  //                             className="p-1 mt-2 cursor-pointer "
  //                             // onClick={() => setShowAll(true)}
  //                           >
  //                             <Link to={`/jobDetails/${item.id}`}>
  //                               <p className="px-2 pt-1 text-xs font-normal text-gray-600">
  //                                 ...more
  //                               </p>
  //                               {/* <button className='mt-2 text-base font-bold'>{item?.title}</button> */}
  //                             </Link>
  //                           </div>
  //                         )}
  //                         {/* {item.required_skill?.length > 4 && !showAll && (
  //                           <div
  //                             className='p-1 mt-2 cursor-pointer '
  //                             onClick={() => setShowAll(true)}
  //                           >
  //                             <p className='px-2 pt-1 text-xs font-normal text-gray-600'>...more</p>
  //                           </div>
  //                         )} */}
  //                       </div>
  //                     </div>

  //                     <div className="flex flex-row justify-between mt-6">
  //                       <div>
  //                         <p>{locations.join("/")}</p>
  //                       </div>
  //                       <div>
  //                         {/* <Button className='rounded-3xl text-white bg-[#0A0A0A]'>Apply</Button> */}
  //                         {currentUser === null ? (
  //                           <Button
  //                             className="rounded-3xl text-white bg-[#0A0A0A]"
  //                             onClick={showDrawer}
  //                           >
  //                             Login To Apply
  //                           </Button>
  //                         ) : item.applied === false ? (
  //                           <Button className="rounded-3xl text-white bg-[#0A0A0A]">
  //                             <Link to={`/jobDetails/${item.id}`}>Apply</Link>
  //                           </Button>
  //                         ) : (
  //                           <div className="flex px-5 py-1">
  //                             <button className="flex flex-wrap">
  //                               <p className="px-2 mt-1 text-base font-medium text-green-600">
  //                                 Applied
  //                               </p>

  //                               <img
  //                                 src={tickIcon}
  //                                 alt="work"
  //                                 className="w-4 h-auto mt-2 mr-3 contentIcon"
  //                               />
  //                             </button>
  //                           </div>
  //                         )}
  //                         {open && (
  //                           <CandidateLogin open={open} onClose={onClose} />
  //                         )}
  //                       </div>
  //                     </div>
  //                   </div>
  //                 </div>
  //               );
  //             })}
  //           </div>
  //           <div className="flex flex-wrap justify-end w-full pr-20 mt-8 mb-4">
  //             <Pagination
  //               className="AntPagination"
  //               showSizeChanger={false}
  //               defaultCurrent={0}
  //               pageSize={paginationModel.pageSize}
  //               current={paginationModel.page + 1}
  //               total={jobDetails?.count}
  //               onChange={(pageNumber) => {
  //                 const newPageNumber = pageNumber - 1;
  //                 const newPaginationData = calculatePaginationData(
  //                   newPageNumber,
  //                   jobDetails?.count,
  //                   paginationModel.pageSize
  //                 );
  //                 console.log("newPaginationData", newPaginationData);
  //                 setPaginationModel(newPaginationData);
  //                 handelPaginationModel(newPaginationData);
  //               }}
  //             />
  //             {/* <pre>{JSON.stringify(paginationModel, 2, null)}</pre> */}
  //           </div>
  //         </div>
  //       </div>
  //       <div className="h-[1px] bg-[#EAEAEA] mt-10"></div>
  //       <div>
  //         <FooterLayout />
  //       </div>
  //     </div>
  //   </>
  // );
};
export default Jobs;
